export default {
  "characters": {
    "setJob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date de naissance"])},
    "delete": {
      "success": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success"])}
      }
    },
    "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
    "idNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro d'identification"])},
    "playerID": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Player ID"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Character"])}
  },
  "chats": {
    "closedAt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "closedBy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "createdAt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "selectChar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "sender": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
  },
  "download": {
    "delete-download-text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voulez-vous vraiment supprimer ce téléchargement ?"])},
    "delete-download-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le téléchargement"])},
    "delete-section-text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voulez-vous vraiment supprimer cette section de téléchargement ? Cela supprimera également tous les autres téléchargements !"])},
    "delete-section-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suppression de la section du téléchargement"])}
  },
  "permissions": {
    "addPermSuccess": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Permission has been added successfully"])},
    "groups": {
      "create-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer un nouveau groupe"])},
      "delete-text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voulez-vous vraiment supprimer le groupe?"])},
      "delete-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le groupe"])},
      "edit-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier le groupe"])},
      "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Groupes"])}
    },
    "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouvelle Autorisation"])},
    "ranks": {
      "edit-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier le grades"])},
      "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
      "level": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Level"])},
      "mcPrefix": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Minecraft - Prefix"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grades"])},
      "titlesingle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grade"])}
    },
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorisations"])}
  },
  "player": {
    "char-amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Possibilité de caractère"])},
    "characters": {
      "headers": {
        "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date de naissance"])},
        "gender": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sexe"])},
        "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
        "id-number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro d'identification"])},
        "last-play": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dernièrement joué"])},
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "player-id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Player ID"])},
        "working": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Working?"])},
        "player": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Player"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Character"])}
    },
    "mod-first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Première utilisation"])},
    "mod-id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ModID"])},
    "mod-last": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dernière utilisation"])},
    "mod-name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom du Mod"])},
    "note": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Note"])},
    "quiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz"])},
    "warnings": {
      "headers": {
        "proof": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preuve"])},
        "reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Motif"])},
        "warned-at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Averti à"])},
        "warner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Warner"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avertissements"])}
    },
    "hints": {
      "create": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer un indice"])}
      },
      "delete": {
        "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voulez-vous supprimer cet indice ?"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer l'indice"])}
      },
      "edit": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier l'indice"])}
      },
      "headers": {
        "note": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Note"])},
        "reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Motif"])},
        "created-at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créé à"])},
        "warner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indiqué par"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indices"])}
    },
    "ban": {
      "reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Motif"])}
    },
    "notification": {
      "error": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
      },
      "success": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success"])}
      }
    }
  },
  "players": {
    "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
    "name-search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom du joueur"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Joueur"])},
    "uuid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["UUID"])}
  },
  "pre-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration - "])},
  "unban": {
    "success": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Success"])}
    }
  },
  "vehicle": {
    "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
    "garage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Garage"])},
    "owner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Propriétaire"])}
  },
  "inventory": {
    "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour"])},
    "boots": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chaussures"])},
    "character": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inventaire du personnage"])},
    "chestplate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Torse"])},
    "close": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer"])},
    "container-unreadable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le contenu de ce conteneur n’a pas pu être lu."])},
    "containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["conteneurs"])},
    "empty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cet inventaire est vide."])},
    "equipment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Équipement"])},
    "helmet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tête"])},
    "hotbar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Barre rapide"])},
    "items-total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["objets au total"])},
    "leggings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jambes"])},
    "load-error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L’inventaire n’a pas pu être chargé."])},
    "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chargement de l’inventaire …"])},
    "occupied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["occupés"])},
    "offhand": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Main secondaire"])},
    "open": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir"])},
    "open-container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrir le conteneur"])},
    "slot": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Emplacement"])},
    "storage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Emplacements d’inventaire"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vue de l’inventaire"])},
    "unreadable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les données d’inventaire enregistrées n’ont pas pu être lues."])},
    "vehicle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inventaire du véhicule"])}
  },
  "property": {
    "address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse"])},
    "balance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solde"])},
    "character": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Propriétaire"])},
    "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
    "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Image"])},
    "lastplayed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dernière connexion"])},
    "note": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Note"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Immobilier"])}
  }
}